import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const criteria = ['คุณเป็นอาจารย์สอนฟุตบอล โค้ช หรือผู้ฝึกสอนในสโมสร โรงเรียน หรืออคาเดมีในไทย', 'คุณเหนื่อยกับการทำงานหนักแต่ไม่มีระบบที่ชัดเจนรองรับ', 'คุณอยากหยุดคิดแผนการสอนใหม่ทุกสัปดาห์ด้วยตัวเอง', 'คุณอยากให้คลาสดำเนินไปได้ดีแม้ในวันที่คุณไม่พร้อม 100%', 'คุณอยากให้ผู้ปกครองเห็นผลลัพธ์ที่จับต้องได้จากการสอนของคุณ', 'คุณอยากพัฒนานักเรียนแต่ละคนได้อย่างเป็นระบบและวัดผลได้'];
export function WhoFor() {
  return <section className="w-full bg-navy-primary py-20 px-4" data-id="element-267">
      <div className="max-w-5xl mx-auto" data-id="element-268">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-display font-bold text-center text-white mb-4" data-id="element-269">
          ระบบนี้เหมาะสำหรับคุณถ้า...
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-270">
          {criteria.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-lg flex gap-4" data-id="element-271">
              <div className="flex-shrink-0" data-id="element-272">
                <div className="w-8 h-8 rounded-full bg-gold-accent flex items-center justify-center" data-id="element-273">
                  <Check className="w-5 h-5 text-navy-primary" data-id="element-274" />
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-275">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}